type FetchConfig = {
  url: RequestInfo;
  init?: RequestInit;
};

type FetchInterceptor = (config: {
  url: RequestInfo;
  init?: RequestInit;
}) => Promise<{ url: RequestInfo; init?: RequestInit }> | { url: RequestInfo; init?: RequestInit };
const fetchInterceptors = new Map<string, FetchInterceptor>();

export function addFetchInterceptor(name: string, interceptor) {
  fetchInterceptors.set(name, interceptor);
}

export async function fetchWithInterceptors(input, init = {}) {
  let config: FetchConfig = { url: input, init };
  for (const interceptor of fetchInterceptors.values()) {
    config = await interceptor(config);
  }
  return fetch(config.url, config.init);
}
